var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header',{attrs:{"title":_vm.guideBookPaper.name,"back-to":_vm.backTo || '/outdoor',"links":_vm.headerLinks,"refresh-key":_vm.unreadPublicationCount}})
}
var staticRenderFns = []

export { render, staticRenderFns }